export interface SwimlaneColumn {
  id: string;
  title: string;
  nodes: string[];
}

export interface SwimlaneConfig {
  id: string;
  title: string;
  subtitle: string;
  color: string;
  columns: SwimlaneColumn[];
}

export const SWIMLANES: SwimlaneConfig[] = [
  {
    id: "code",
    title: "CODE",
    subtitle: "Develop / Build",
    color: "#2f6df5",
    columns: [
      { id: "plan", title: "PLAN", nodes: ["Jira", "Requirements"] },
      { id: "code", title: "CODE", nodes: ["VS Code", "pnpm", "Mantine UI"] },
      { id: "commit", title: "COMMIT", nodes: ["GitHub"] },
      {
        id: "build",
        title: "BUILD",
        nodes: ["GitHub Actions", "Vitest", "ESLint"],
      },
      { id: "test", title: "TEST", nodes: ["Unit Tests", "Quality Gates"] },
      {
        id: "package",
        title: "PACKAGE",
        nodes: ["Docker Build", "Artifact Registry"],
      },
    ],
  },
  {
    id: "deploy",
    title: "DEPLOY",
    subtitle: "Integration / Delivery / Testing",
    color: "#7a49f2",
    columns: [
      { id: "deploy", title: "DEPLOY", nodes: ["GKE Staging"] },
      { id: "configure", title: "CONFIGURE", nodes: ["Helm", "Ingress"] },
      {
        id: "uat",
        title: "SIT / UAT / Perf Test",
        nodes: ["Manual Approval", "Smoke Tests"],
      },
      {
        id: "prod",
        title: "PRODUCTION",
        nodes: ["GKE Production", "Cloud Monitoring"],
      },
    ],
  },
];

export const DOC_LINKS: Record<string, string> = {
  "GitHub Actions": "/docs/devops/ci",
  "Docker Build": "/docs/devops/docker",
  "Artifact Registry": "/docs/devops/artifact-registry",
  "GKE Staging": "/docs/devops/environments#staging",
  "GKE Production": "/docs/devops/environments#production",
  Helm: "/docs/devops/helm",
  Ingress: "/docs/infra/ingress",
};
